import { Component, Input, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { CardLinkOfferLocationDetail } from '@fgb/core';
import { fgbAnimations } from '@fgb/portal-component-library/src/lib/shared/animations';
import { fromEvent, Subject } from 'rxjs';
import { map, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fgbcl-card-link-offer-locations-list',
  templateUrl: './card-link-offer-locations-list.component.html',
  styleUrls: ['./card-link-offer-locations-list.component.scss'],
  animations: [fgbAnimations],
})
export class CardLinkOfferLocationsListComponent implements OnInit, OnDestroy {
  pageNo: number = 1;
  locationCount: number;
  totalPage: number;
  intialHeight: number = 0;
  listHeight: number = 0;
  @Input() showAnimation: boolean = true;
  @Input() pageSize: number = 6;
  @Input() set cardLinkOfferLocationDetails(value: CardLinkOfferLocationDetail[]) {
    if (value) {
      this._cardLinkOfferLocationDetails = value;
      this._init();
    }
  }
  @ViewChild('listContainer', { read: ElementRef, static: false }) listContainer: ElementRef;

  get cardLinkOfferLocationDetails() {
    return this._cardLinkOfferLocationDetails;
  }

  private _cardLinkOfferLocationDetails: CardLinkOfferLocationDetail[];
  private _destroyed$ = new Subject<void>();

  constructor() {}

  ngOnInit(): void {
    if (!this.showAnimation) {
      return;
    }

    fromEvent(window, 'resize')
      .pipe(
        map(() => window.innerWidth < 992),
        distinctUntilChanged(),
        takeUntil(this._destroyed$)
      )
      .subscribe(() => {
        // Re-initialize height if switched to mobile to get initial height
        this.pageNo = 1;
        setTimeout(() => (this.intialHeight = this.listHeight = this.listContainer.nativeElement.clientHeight));
      });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  private _init(): void {
    this.locationCount = this.cardLinkOfferLocationDetails.length;
    this.totalPage = Math.ceil(this.locationCount / this.pageSize);
    setTimeout(() => (this.intialHeight = this.listHeight = this.listContainer.nativeElement.clientHeight));
  }

  showMore(): void {
    if (this.pageNo === this.totalPage) {
      return;
    }

    this.pageNo++;
    this._initHeight();
  }

  showLess(): void {
    this.pageNo = 1;
    this._initHeight();
  }

  private _initHeight(): void {
    setTimeout(() => {
      this.listHeight = this.listContainer.nativeElement.clientHeight;
    }, 300);
  }
}
